import { render, staticRenderFns } from "./ProfileIdentVolunteerForm.vue?vue&type=template&id=d247355e"
import script from "./ProfileIdentVolunteerForm.vue?vue&type=script&lang=ts"
export * from "./ProfileIdentVolunteerForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIdentVolunteerForm.vue?vue&type=style&index=0&id=d247355e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports